import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { blogReducer } from "./blogReducer/blogReducer";
import { videoReducer } from "./videoReducer/videoReducer";

const persistConfig = {
  key: "root",
  storage,
  //   whitelist: ["user"],
};

const rootReducer = combineReducers({
  video: videoReducer,
  blog: blogReducer,
});

export default persistReducer(persistConfig, rootReducer);
